import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between px-5 pt-4" }
const _hoisted_2 = { class: "font-size-12-400" }
const _hoisted_3 = { class: "font-size-12-400 d-flex align-center ga-1" }
const _hoisted_4 = { class: "d-flex align-center ga-1" }
const _hoisted_5 = {
  key: 0,
  class: "secondary-button-color"
}
const _hoisted_6 = {
  key: 1,
  class: "avatar-container__initials primary-background-button-color"
}
const _hoisted_7 = { class: "consultation-description-container" }
const _hoisted_8 = { class: "font-size-14-600" }
const _hoisted_9 = { class: "subtitle pb-1" }
const _hoisted_10 = { class: "font-size-12-600 d-flex align-center ga-1" }
const _hoisted_11 = { class: "font-size-10-400 font-grey-dark" }
const _hoisted_12 = { class: "font-size-10-600 primary-button-color text-underline" }
const _hoisted_13 = { key: 1 }

import {computed} from "vue";
import {useRouter} from "vue-router";
import moment from 'moment';
import Icon from "@/components/Icons/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppointmentsCard',
  props: {
  consultation: {
    type: Object,
  },
  tab: {
    type: String
  },
},
  setup(__props) {

const router = useRouter();

const props = __props;

const getAvatar = computed(() => {
  if (props.consultation.assignee_id && props.consultation.assignee) {
    const firstName = props.consultation.assignee.first_name ?? '';
    const lastName = props.consultation.assignee.last_name ?? '';

    if (props.consultation.assignee.image && props.consultation.assignee.image.file) {
      return {
        image: props.consultation.assignee.image.file.file_path ?? '',
        initials: null,
        name: `${firstName} ${lastName}`
      };
    }

    if (firstName || lastName) {
      return {
        image: null,
        initials: (firstName[0] + (lastName[0] || '')).toUpperCase(),
        name: `${firstName} ${lastName}`
      };
    }
  }
  return null;
});

const getConsultationDateAndDuration = computed(() => {
  if (props.consultation?.event !== null) {
    return {
      duration: props.consultation?.event.duration ?? '',
      date: moment(props.consultation?.event.start_date).format("DD MMMM, YYYY, h:mm a") ?? '',
    }
  }

  //unconfirmed or canncelled
  const dateString = props.consultation?.consultation?.status == 'cancelled' ? 'Cancelled' : 'Unconfirmed';

  return {
    duration: '-',
    date: dateString,
  }
})

const getMethodIcon = computed(() => {
  let icon;

  switch (props.consultation?.method) {
    case 'In Person':
      icon = 'location-icon'
      break
    case 'Phone Call':
      icon = 'phone-icon'
      break
    case 'Video':
      icon = 'video-icon'
      break
    default:
      icon = null
  }

  return icon
})

const getPackagesOrServices = computed(() => {
  return props.consultation?.consultation?.package_id ? props.consultation?.consultation?.package?.name : 'Service'
})

const getPaymentStatus = computed(() => {
  switch (props.consultation?.consultation?.order?.payment_status) {
    case 'paid':
      return 'Paid'
    case 'partial':
      return 'Part paid'
    default:
      return 'Not paid'
  }
})

const onJoin = () => {
  if (props.consultation.link) {
    window.open(props.consultation.link, '_blank', 'noopener,noreferrer');
  } else {
    router.push({ name: 'video-session', params: { eventId: props.consultation.event.id } });
  }
}

const book = () => {
  if (props.consultation.clinic_package_id) {
    let clinicServiceId = props.consultation.consultation.package.services.filter((item) => {
      return props.consultation.clinic_service_id === item.clinic_service_id;
    })

    router.push({
      name: 'book-service', params: {id: props.consultation.clinic_service?.id}, query: {
        packageServiceId: clinicServiceId[0].id,
        orderId: props.consultation.consultation.order_id,
        consultationId: props.consultation.consultation_id
      }
    })
  } else {
    router.push({name: 'book-service', params: {id: props.consultation?.clinic_service_id}})
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "font-size-12-400 mx-5 my-3 card-container" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(getConsultationDateAndDuration.value.date), 1),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(getConsultationDateAndDuration.value.duration) + " ", 1),
          _createElementVNode("div", _hoisted_4, [
            (getMethodIcon.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "|"))
              : _createCommentVNode("", true),
            (getMethodIcon.value)
              ? (_openBlock(), _createBlock(Icon, {
                  key: 1,
                  icon: getMethodIcon.value
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode(_component_v_sheet, {
        class: _normalizeClass([{'card-container-sheet': getAvatar.value, 'card-container-sheet-unconfirmed': !getAvatar.value}, "pa-4"])
      }, {
        default: _withCtx(() => [
          (getAvatar.value)
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "avatar-container"
              }, {
                default: _withCtx(() => [
                  (getAvatar.value.image)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: _normalizeStyle({ backgroundImage: `url(${getAvatar.value.image})` }),
                        class: "avatar-container__image"
                      }, null, 4))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(getAvatar.value.initials), 1)),
                  _createVNode(_component_v_overlay, {
                    activator: "parent",
                    "location-strategy": "connected",
                    "scroll-strategy": "close"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "pa-2" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(getAvatar.value.name), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(__props.consultation?.clinic_service?.name ?? '-'), 1),
            _createElementVNode("p", _hoisted_9, " (" + _toDisplayString(getPackagesOrServices.value) + ") ", 1),
            _createElementVNode("p", _hoisted_10, [
              _createTextVNode(_toDisplayString(__props.consultation?.consultation?.order?.total_display ?? '-') + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass([{'font-success': getPaymentStatus.value === 'Paid','font-danger': getPaymentStatus.value === 'Not paid', 'font-warning': getPaymentStatus.value === 'Part paid'}, "font-size-10-400"])
              }, " (" + _toDisplayString(getPaymentStatus.value) + ") ", 3)
            ]),
            _createElementVNode("p", _hoisted_11, [
              _cache[1] || (_cache[1] = _createTextVNode(" Order ID: ", -1)),
              _createElementVNode("span", _hoisted_12, " #" + _toDisplayString(__props.consultation?.consultation.order_id ?? ''), 1)
            ])
          ]),
          (__props.tab !== 'cancelled')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (__props.tab === 'upcoming' && getMethodIcon.value === 'video-icon' && __props.consultation?.assignee && __props.consultation?.event)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "b-round-20 join-video-btn mb-2",
                      elevation: "0",
                      height: "32px",
                      "x-small": "",
                      onClick: onJoin
                    }, {
                      default: _withCtx(() => [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mr-1" }, "Join", -1)),
                        _createVNode(Icon, { icon: "video-icon-lg" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (__props.tab === 'upcoming' && !__props.consultation?.event)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      class: "b-round-20 outline-btn primary-button mb-2",
                      elevation: "0",
                      height: "32px",
                      variant: "outlined",
                      width: "82px",
                      "x-small": "",
                      onClick: book
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode(" Book ", -1)
                      ]))]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  class: "b-round-20 outline-btn white-btn",
                  elevation: "0",
                  height: "32px",
                  variant: "outlined",
                  width: "82px",
                  "x-small": "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'order-view', params: { id: __props.consultation?.consultation.order_id } })))
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" View ", -1)
                  ]))]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}
}

})